/** Ensures user-facing error copy ends with sentence punctuation. */
export function formatErrorMessage(message: string): string {
  const t = message.trim();
  if (!t) return t;
  return /[.!?]$/.test(t) ? t : `${t}.`;
}
